module.exports = __webpack_public_path__ + "img/database.d91b0867.png";